import { render } from "./Cabecalho.vue?vue&type=template&id=d63da5aa&ts=true"
import script from "./Cabecalho.vue?vue&type=script&lang=ts"
export * from "./Cabecalho.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__